module.exports = __webpack_public_path__ + "media/newChat.568c4522.mp3";